<template>
  <v-card>
    <v-card-title class="primary">
      <h5 class="white--text">{{$t('message.layout.reports')}}</h5>
      <v-spacer></v-spacer>
      <v-btn color="primary" fab small icon @click="$emit('closeDialog')">
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text class="pa-1 px-4" style="max-height: 75vh;overflow-y:scroll">
      <template v-if="loading">
        <div class="subtitle-1 mt-1">{{ $t('message.hse.gettingFolders') }}</div>
        <v-progress-linear rounded height="6" indeterminate color="primary"></v-progress-linear>
      </template>
      <template v-else>
        <v-radio-group v-model="selectedReport">
         <template v-for="(report, index) in documentReportsList">
            <v-radio :value="report.id" :key="index">
              <template v-slot:label>
                <v-card class="ml-1 pa-1 pl-4" outlined tile width="100%" elevation="1">
                  <p class="mb-0 font-weight-medium">{{report.title}}</p>
                </v-card>
              </template>
            </v-radio>
          </template>
        </v-radio-group>
      </template>
      <v-alert color="info" dark icon="mdi-cloud" border="left" prominent outlined v-if="documentReportsList.length <= 0 && !loading">
        {{ $t('message.common.noResults') }}
      </v-alert>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="pa-1">
      <v-btn color="primary" @click="$emit('showQuickReportDialog')" class="ma-1">{{$t('message.document.quickReport')}}</v-btn>
      <v-flex class="text-center">
        <v-btn color="primary" :disabled="!selectedReport" @click="downloadDocuments(1)" class="ma-1" :loading="downloadingReport">{{$t('message.document.downloadOnly')}}</v-btn>
        <v-btn color="primary" :disabled="!selectedReport" @click="downloadDocuments(2)" class="ma-1" :loading="downloadAndSaveReport">{{$t('message.document.downloadSave')}}</v-btn>
        <v-btn color="primary" :disabled="!selectedReport" @click="downloadDocuments(3)" class="ma-1" :loading="onlySaveReportLoading">{{$t('message.document.onlySave')}}</v-btn>
      </v-flex>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: ['module', 'sharepointId'],
  data () {
    return {
      MODULE_URL: 'documentreports',
      loading: false,
      documentReportsList: [],
      downloadingReport: false,
      selectedReport: null,
      downloadAndSaveReport: false,
      onlySaveReportLoading: false
    }
  },
  mounted () {
    this.getBuilderReportsByModule()
  },
  methods: {
    getBuilderReportsByModule () {
      this.loading = true
      this.$_executeApi('get', `${this.MODULE_URL}/get_by_module/${this.module}`).then(({ data }) => {
        this.documentReportsList = data
      }).finally(() => {
        this.loading = false
      })
    },
    downloadDocuments (action) {
      if (this.selectedReport) {
        // action 1-download only, 2-download and save
        if (action === 1) this.downloadingReport = true
        else if (action === 2) this.downloadAndSaveReport = true
        else if (action === 3) this.onlySaveReportLoading = true
        this.$_executeApi('post', `${this.MODULE_URL}/generate_report/${this.selectedReport}?uploadtodms=${[2, 3].includes(action)}&sharepoint_id=${this.sharepointId}`).then((response) => {
          if (action !== 3) window.open(process.env.VUE_APP_URL + 'file/download/?fileName=' + response.data, '_blank')
        }).finally(() => {
          if (action === 1) this.downloadingReport = false
          else if (action === 2) this.downloadAndSaveReport = false
          else if (action === 3) this.onlySaveReportLoading = false
          this.$emit('closeDialog')
        })
      }
    }
  }
}
</script>

<style>
</style>
